import React from 'react';
import classNames from 'classnames/bind';
import styles from './AiDetail.scss';

const cx = classNames.bind(styles);

const AiDetail = ({ handleClose }) => {
  return (
    <div className={cx('AiDetail')}>
      <div className="close" onClick={handleClose}></div>
      <div className="detail-title">
        <h2>오케이 닥터 상세 스펙</h2>
      </div>

      <div className="detail-contents">
        <div className="detail-subtitle">
          <h3>제품 정보</h3>
        </div>
        <div className="detail-text">
          <ul className="detail-text-list">
            <li className="list">
              <span className="title">제품명</span>
              <span>오케이 닥터 (OK Doctor)</span>
            </li>
            <li className="list">
              <span className="title">기자재의 명칭</span>
              <span className="text">
                특정 소출력 무선기기(무선렌은 포함한무선접속시스템용 무선기기)
              </span>
            </li>
            <li className="list">
              <span className="title">모델명</span>
              <span>NL-V100KR</span>
            </li>
            <li className="list">
              <span className="title">제조자</span>
              <span>(주)인포마크</span>>
            </li>
            <li className="list">
              <span className="title">공급자</span>
              <span>(주)퀄슨</span>
            </li>
            <li className="list">
              <span className="title">구성품</span>
              <span>
                어학기본체, 전용 어댑터, 명령어 가이드,
                <br />
                제품 구성 및 품질 보증서
              </span>
            </li>
          </ul>
        </div>

        <div className="detail-subtitle">
          <h3>제품 사양</h3>
        </div>
        <div className="detail-text">
          <ul className="detail-text-list">
            <li className="list">
              <span className="title">사용 전원</span>
              <span>
                정격 입력 전압: 9V = 3A
                <br />
                정격 출력 전압: 3.6V
              </span>
            </li>
            <li className="list">
              <span className="title">배터리</span>
              <span className="text">3000mAh 내장 배터리</span>
            </li>
            <li className="list">
              <span className="title">디스플레이</span>
              <span>5.46”Full HD (1920X1080)</span>
            </li>
            <li className="list">
              <span className="title">스피커</span>
              <span>
                2.75”Woofer Driver 1pcs,
                <br />
                23mm Tweeter 3pcs,
                <br />
                2.2”Passive Radiator 2pcs,
                <br />
                20W
              </span>
            </li>
            <li className="list">
              <span className="title">wifi</span>
              <span>
                지원 규격: 802.11a/b/g/n/ac
                <br />
                사용 주파수: 2.4GHz
              </span>
            </li>
            <li className="list">
              <span className="title">블루투스</span>
              <span>
                지원 규격: Bluetooth 4.2,
                <br />
                사용 주파수: 2.4GHz
              </span>
            </li>
            <li className="list">
              <span className="title">크기</span>
              <span>180mm X 177.2mm X 164.7mm</span>
            </li>
            <li className="list">
              <span className="title">무게</span>
              <span>1487g</span>
            </li>
            <li className="list">
              <span className="title">권장 동작 온도</span>
              <span>5 ~ 35°C</span>
            </li>
            <li className="list">
              <span className="title">최대 동작 온도</span>
              <span>0 ~ 40°C</span>
            </li>
            <li className="list">
              <span className="title">KC 인증번호</span>
              <span>R-CRM-IMW-NL-V100KR</span>
            </li>
            <li className="list">
              <span className="title">제조일자</span>
              <span>별도표기</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AiDetail;
